import { FullModel } from "./models/fullModel.models";
import axiosInstance from "./axios";
import { Family } from "./models/fullProductData.models";
import { combineSearchParams } from "../utils/urlUtils";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchFullModelData = async (
  bearerToken: string,
  searchStrings: string[],
  page: number = 1
): Promise<{
  data: FullModel[];
  isSynkkaData: boolean;
  synkkaFamily: Family;
}> => {
  try {
    const response = await axiosInstance.get(
      searchStrings?.length > 0
        ? `${apiUrl}/Products/fullmodeldata${combineSearchParams(searchStrings)}&page=${page} `
        : `${apiUrl}/Products/fullmodeldata?page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return {
      data: response.data,
      isSynkkaData: false,
      synkkaFamily: Family.product_model,
    };
  } catch (error) {
    console.error("Failed to fetch full model data:", error);
    throw error;
  }
};

export const fetchCompanyFullModelData = async (
  bearerToken: string,
  companyId: number,
  searchStrings: string[],
  isEanSearch: boolean = false
): Promise<{
  data: FullModel[];
  isSynkkaData: boolean;
  synkkaFamily: Family;
}> => {
  try {
    const url = `${apiUrl}/Products/${companyId}/fullmodeldata/recursive${combineSearchParams(searchStrings)}`;
    let response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });

    // If response data is empty array, fetchFullModelData without companyId
    // This is a fallback to ensure we get model data even if the company-specific endpoint returns no results
    if (response.data?.length === 0 && isEanSearch) {
      const secondResult = await fetchFullModelData(bearerToken, searchStrings);

      if (secondResult?.data?.length > 0) {
        return {
          data: secondResult.data,
          isSynkkaData: true,
          synkkaFamily: Family.product_model,
        };
      }
    }

    return {
      data: response.data,
      isSynkkaData: false,
      synkkaFamily: Family.product_model,
    };
  } catch (error) {
    console.error("Failed to fetch company full model data:", error);
    throw error;
  }
};
